export default {
    key: 'SbxWD0Qe66nmXQpV2Fx08Uihi2TknULlRHpT2XgyRPs'
}